import styled from '@emotion/styled';
import {colors} from '@styles/colors';
import {mq} from '@styles/helpers';
import {Devices} from '@styles/tokens';
import Logo from '@components/Layout/Logo';
import ChevronLeft from '@assets/svg/chevron-left.svg'
import Tooltip from '@components/Tooltips/Tooltip';
import WarningIcon from '@assets/svg/warning.svg'

export const Header = styled.header`
  position: fixed;
  height: ${(props) => props.theme.layout.headerHeight}px;

  width: 100%;
  padding: 0 var(--padding);
  background-color: ${colors.offWhite};
  top: 0;
  z-index: 220;

  ${mq(Devices.tablet)} {
    width: 100%;
    margin: 0;
  }
`;


export const FillSpaceIphone = styled.div`
  width:100%;
  height:105px;
  position: absolute;
  top:-48px;
  left:0px;
  background:#f5f5f5;
  z-index: 1;
`;


export const StyledLogo = styled(Logo)`
  margin-right: auto;
`;

export const HeaderContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: start;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  border-bottom: 1px solid #cecece;
  z-index: 2;
  > a {
    ${mq(Devices.tablet)} {
      margin-right: 0;
    }
  }

  ${mq(Devices.tablet)} {
    padding: 0 2px 0 4px;
  }
`;

export const BackButton = styled.button`

  margin-right:20px;
  margin-left: auto;
  margin-top:-4px;
  cursor:pointer;
  width:20px;
  height:20px;
`;

export const BackArrow = styled(ChevronLeft)`
  width:100%;
  height:100%;
  svg{
    width:100%;
    height:100%;
    path{

    }
  }
`;

export const NotificationButton = styled.div`
  width:26px;
  height:26px;
  margin-right:15px;
  position: relative;
  cursor: pointer;

  svg{
    width:100%;
    height:100%;
    path{
      fill:#727272;
    }
  }
`;

export const NotificationCount = styled.div`
  position: absolute;
  top: -4px;
  right: -4px;
  width: 14px;
  height: 14px;
  background: red;
  color: #fff;
  font-size: 8px;
  font-weight: 600;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
`;

export const FilterButton = styled.button`
  display: flex;
  margin-right:8px;
  cursor:pointer;
  width:28px;
  height:28px;
  align-items: center;

  svg{
    width:100%;
    height:100%;
    path{
      fill:#727272;
    }
  }
`;

export const CTooltip = styled(Tooltip)<{isSettings}>`
  margin-left: 15px;
`;

export const FilterText = styled.div<{isSettings:boolean}>`
  position:relative;
  margin-left: ${props => props.isSettings?"unset":"auto"};
  display:flex;
  align-items: center;
  
  div{
    text-align:right;
  }
  p{
    font-size: 14px;
  }
  p:nth-child(2){
    font-size: 10px;
  }
`;

export const Warning = styled(WarningIcon)`
  margin-top: 5px;
  margin-right: 10px;
  width:24px;
  height:24px;
  path{
    fill:#f0711f;
  }
`;